import { Routes, RouterModule } from '@angular/router';
import { HisAuthGuard, HisBootstrapService } from 'hisng';
import { BusinesstripApplicationFormComponent } from './component/businesstripapplication-form.component';
import { BusinesstripApplicationOverviewComponent } from './component/businesstripapplication-overview.component';
import { BusinesstripApplicationSearchResultComponent } from './component/businesstripapplication-search-result.component';
import { BusinesstripApplicationSearchComponent } from './component/businesstripapplication-search.component';

export const ROUTE_CONFIG: Routes = [
    {
        path: 'businesstripapplication/create',
        resolve: { boot: HisBootstrapService },
        component: BusinesstripApplicationFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_CREATE_BUSINESSTRIPAPPLICATION'],
            modules: ['HISINONERKA']
        }
    },
    {
        path: 'businesstripapplication/search',
        resolve: { boot: HisBootstrapService },
        component: BusinesstripApplicationSearchComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_VIEW_BUSINESSTRIPAPPLICATION'],
            modules: ['HISINONERKA']
        }
    },
    {
        path: 'businesstripapplication/searchresult',
        resolve: { boot: HisBootstrapService },
        component: BusinesstripApplicationSearchResultComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_VIEW_BUSINESSTRIPAPPLICATION'],
            modules: ['HISINONERKA']
        }
    },
    {
        path: 'businesstripapplication/edit/:id',
        resolve: { boot: HisBootstrapService },
        component: BusinesstripApplicationFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_EDIT_BUSINESSTRIPAPPLICATION'],
            modules: ['HISINONERKA']
        }
    },
    {
        path: 'businesstripapplication/overview/:id',
        resolve: { boot: HisBootstrapService },
        component: BusinesstripApplicationOverviewComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_VIEW_BUSINESSTRIPAPPLICATION'],
            modules: ['HISINONERKA']
        }
    },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BusinesstripApplicationManagementRoutesModule = RouterModule.forChild( ROUTE_CONFIG );
